<template>
  <div
    class="audio-player"
    @click.stop="(e) => {
      speedShow = false
      findChapterFrom(e)
    }"
    :style="{
      marginTop: (typeof content.contentStyle.marginTop === 'number' && (content.contentStyle.marginTop + 'rem')) || '',
      marginBottom: (typeof content.contentStyle.marginBottom === 'number' && (content.contentStyle.marginBottom + 'rem')) || '',
      width: (typeof content.contentStyle.width === 'string') ? content.contentStyle.width :
        (typeof content.contentStyle.width === 'number') ? (content.contentStyle.width + 'rem') : '',
    }"
  >
    <audio
      id="myAudio"
      ref="audio"
      controls
      :src="content.url"
      @timeupdate="audioTimeupdate"
      @playing="playing = true"
    ></audio>
    <div class="audio-top">
      <div class="audio-title">{{ content.title }}</div>
      <div class="audio-action">
        <div class="audio-speed">
          <div class="speed-text" @click.stop="(e) => {
            speedShow = !speedShow
            findChapterFrom(e)
          }">倍速：{{ speedOptions[speedActive] }}</div>
          <div class="speed-select" v-if="speedShow">
            <div
              v-for="(item, index) in speedOptions"
              :key="index"
              class="speed-item"
              :class="speedActive === index ? 'speed-item-active' : ''"
              @click.stop="changeSpeed($event, index)"
            >{{ item }}</div>
          </div>
        </div>
        <div class="audio-btn audio-play" v-if="!playing" @click.stop="audioPlay">
          <img :src="require('@/assets/images/common/audio-play.png')" alt="">
        </div>
        <div class="audio-btn audio-pause" v-else @click.stop="audioPlay">
          <img :src="require('@/assets/images/common/audio-pause.png')" alt="">
        </div>
      </div>
    </div>
    <div class="audio-progress-box">
      <div class="prograss-line-box" ref="prograssActive" v-on:[prograssAction]="handleTouchStart">
        <div class="prograss-line">
          <div class="prograss-line-active" :style="'width: ' + prograssWidth + 'px;'"></div>
          <div class="prograss-line-btn" :style="'left: ' + prograssWidth + 'px;'"></div>
        </div>
      </div>
      <div class="audio-start-time">{{ playTime }}</div>
      <div class="audio-end-time">{{ durationTime }}</div>
    </div>
  </div>
</template>

<script>
/*
音频播放器
*/
export default {
  name: "audioPlayer",
  inject: {
    findChapterFrom: {
      default: () => {},
    },
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  data() {
    return {
      playing: false,
      playTime: '00:00',
      playTime_s: 0,
      durationTime: '00:00',
      duration_s: 0,
      prograssWidth: 0,
      speedShow: false,
      speedOptions: ['0.5', '1.0', '1.5', '2.0'],
      speedActive: 1,
      prograssAction: 'touchstart',
    }
  },
  mounted() {
    if(this.device.isMobile) {
      this.prograssAction = 'touchstart'
    }else{
      this.prograssAction = 'mousedown'
    }
    this.$refs.audio.addEventListener("canplay", () => {
      const duration_s = this.$refs.audio.duration
      this.duration_s = duration_s
      this.durationTime = this.timeFormat(duration_s);
    })
  },
  beforeDestroy() {
    this.$refs.audio.removeEventListener("canplay", () => {
      const duration_s = this.$refs.audio.duration
      this.duration_s = duration_s
      this.durationTime = this.timeFormat(duration_s);
    })
  },
  methods: {
    audioPlay(e) {
      if(this.playing){
        this.$refs.audio.pause();
        this.playing = false;
      }else{
        this.$refs.audio.play();
        this.playing = true;
      }
      this.findChapterFrom(e)
    },
    audioTimeupdate(e) {
      const nowPlayingTime = e.target.currentTime;
      const lessonTime = e.target.duration;
      // const lessonTime = this.lessonData.duration_s;
      const prograssWidth = (this.$refs.prograssActive || {}).offsetWidth;

      const playerTime = this.timeFormat(nowPlayingTime);
      this.playTime = playerTime;

      this.prograssWidth = (nowPlayingTime / lessonTime) * prograssWidth;
    },
    handleTouchStart(e) {
      if(this.device.isMobile) {
        this.setValue(e.touches[0]);
        document.addEventListener("touchmove", this.handleTouchMove, { passive: false });
        document.addEventListener("touchup", this.handleTouchEnd);
        document.addEventListener("touchend", this.handleTouchEnd);
        document.addEventListener("touchcancel", this.handleTouchEnd);
      }else{
        this.setValue(e);
        document.addEventListener("mousemove", this.handleTouchMove, { passive: false });
        document.addEventListener("mouseup", this.handleTouchEnd);
        document.addEventListener("mouseleave", this.handleTouchEnd);
        document.addEventListener("mouseout", this.handleTouchEnd);
      }
    },
    handleTouchMove(e) {
      if(this.device.isMobile) {
        this.setValue(e.changedTouches[0]);
      }else{
        this.setValue(e);
      }
      e.preventDefault();
    },
    handleTouchEnd(e) {
      if(this.device.isMobile) {
        this.setValue(e.changedTouches[0]);
        this.$refs.audio.currentTime = this.playTime_s;
        document.removeEventListener("touchmove", this.handleTouchMove, { passive: false });
        document.removeEventListener("touchup", this.handleTouchEnd);
        document.removeEventListener("touchend", this.handleTouchEnd);
        document.removeEventListener("touchcancel", this.handleTouchEnd);
      }else{
        this.setValue(e);
        this.$refs.audio.currentTime = this.playTime_s;
        document.removeEventListener("mousemove", this.handleTouchMove, { passive: false });
        document.removeEventListener("mouseup", this.handleTouchEnd);
        document.removeEventListener("mouseleave", this.handleTouchEnd);
        document.removeEventListener("mouseout", this.handleTouchEnd);
      }
    },
    // 从点击位置更新 value
    setValue(e) {
      const $el = this.$el;
      let prograssWidth = (this.$refs.prograssActive || {}).offsetWidth;
      let moveX = e.clientX - ((document.body.clientWidth - prograssWidth) / 2);

      if(moveX < 0){
          moveX = 0
      }else if(moveX > prograssWidth){
          moveX = prograssWidth;
      }
      let playerTime = (moveX / prograssWidth) * this.duration_s;

      this.prograssWidth = moveX;
      this.playTime_s = playerTime;
      this.playTime = this.timeFormat(playerTime);
    },
    changeSpeed(e, index) {
      this.speedActive = index;
      this.$refs.audio.playbackRate = this.speedOptions[index];
      this.findChapterFrom(e)
    },

    timeFormat: function(second) {
      let secondType = typeof second;

      if (secondType === "number" || secondType === "string") {
        second = parseInt(second);

        let hours = Math.floor(second / 3600);
        second = second - hours * 3600;
        let mimute = Math.floor(second / 60);
        second = second - mimute * 60;
        if(hours > 0){
          return ("0" + hours).slice(-2) + ":" + ("0" + mimute).slice(-2) + ":" + ("0" + second).slice(-2);
        }
        return ("0" + mimute).slice(-2) + ":" + ("0" + second).slice(-2);
      } else {
        return "00:00";
      }

    }
  }
}
</script>

<style lang="scss" scoped>
.audio-player{
  width: calc(100% - 40rem);
  text-indent: 0;
  background: #fff;
  box-shadow: 0rem 5rem 25rem 0rem rgba(177,177,177,0.24);
  border-radius: 10rem;
  margin: 0 auto 40rem;
  padding: 24rem 30rem;

  #myAudio{
    display: none;
  }

  .audio-top{
    display: flex;
    justify-content: space-between;
    align-items: center;

    .audio-title{
      font-size: 28rem;
      line-height: 38rem;
      color: #333;
      font-family: Arial;
      font-weight: bold;
      padding-left: 92rem;
      position: relative;
      min-height: 68rem;
      display: flex;
      align-items: center;

      &:before{
        content: '';
        width: 68rem;
        height: 68rem;
        position: absolute;
        left: 0;
        top: 50%;
        margin-top: -34rem;
        background: url("~@/assets/images/common/audio-icon.png") center no-repeat;
        background-size: contain;
        border-radius: 10rem;
      }
    }

    .audio-action{
      flex: 0 0 210rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-left: 20rem;

      .audio-speed{
        font-size: 28rem;
        line-height: 38rem;
        color: #999;
        cursor: pointer;
        position: relative;

        .speed-select{
          position: absolute;
          width: 146rem;
          position: absolute;
          top: 50rem;
          left: 50%;
          transform: translateX(-50%);
          background: #fff;
          box-shadow: 0px 5px 16px 0px rgba(153,153,153,0.35);
          z-index: 5;

          .speed-item{
            font-size: 28rem;
            line-height: 79rem;
            border-bottom: 1rem solid #E3E3E3;
            color: #999;
            text-align: center;
          }

          .speed-item-active{
            color: #5CA683;
            font-weight: bold;
          }
        }
      }
      .audio-btn{
        width: 60rem;
        height: 60rem;
        cursor: pointer;
        img{
          width: 100%;
          height: 100%;
          display: block;
        }
      }
    }
  }

  .audio-progress-box{
    position: relative;
    margin-top: 39rem;
    margin-bottom: 40rem;

    .prograss-line-box{
      .prograss-line{
        width: 100%;
        height: 8rem;
        background: #C3CFC9;
        border-radius: 4rem;
        position: relative;

        .prograss-line-active{
          height: 8rem;
          background: #5CA683;
          border-radius: 4rem;
        }

        .prograss-line-btn{
          position: absolute;
          top: 50%;
          left: 0;
          transform: translate(-50%, -50%);
          width: 28rem;
          height: 28rem;
          background: url("~@/assets/images/common/prograss-icon.png") center no-repeat;
          background-size: 28rem 28rem;
        }
      }

    }

    .audio-start-time{
      font-size: 24rem;
      line-height: 38rem;
      color: #999;
      position: absolute;
      left: 0;
      top: 16rem;
    }

    .audio-end-time{
      font-size: 24rem;
      line-height: 38rem;
      color: #999;
      position: absolute;
      right: 0;
      top: 16rem;
    }
  }
}
</style>